// @flow
import parseFlightQuery from './parseFlightQuery'

// Types
import type { PartialFlight } from './parseFlightQuery'

/**
 * Analys and compare fligth info with query
 * to return final values like flightNumber
 * @param  {string} query
 * @param  {FlightInfo} flightInfo
 * @return {Flight}
 */
const getFlightData = (query: string, airlineCode: string): PartialFlight => {
  const parsedFlight = parseFlightQuery(query) || {}
  const finalAirlineCode = airlineCode || parsedFlight.airlineCode || ''
  return {
    flightCode: parsedFlight.flightCode,
    flightNumber: parsedFlight.flightNumber,
    airlineCode: finalAirlineCode,
  }
}

export default getFlightData
